import { render, staticRenderFns } from "./c-master.vue?vue&type=template&id=43ce392e&scoped=true"
import script from "./c-master.vue?vue&type=script&lang=js"
export * from "./c-master.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ce392e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43ce392e')) {
      api.createRecord('43ce392e', component.options)
    } else {
      api.reload('43ce392e', component.options)
    }
    module.hot.accept("./c-master.vue?vue&type=template&id=43ce392e&scoped=true", function () {
      api.rerender('43ce392e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mconfigs/views/master/c-master.vue"
export default component.exports